import { EMAIL_CREATION_FORM_FIELD_NAME_TEXT_OR_GOOGLE_TEMPLATE } from '../EmailCreationForm.constants'

export const EmailSelectTemplateToTestOptionValue = {
  googleTemplate: 'GoogleTemplate',
  textTemplate: 'TextTemplate',
}

export const EMAIL_SELECT_TEMPLATE_TO_TEST_INITIAL_VALUES = {
  [EMAIL_CREATION_FORM_FIELD_NAME_TEXT_OR_GOOGLE_TEMPLATE]:
    EmailSelectTemplateToTestOptionValue.textTemplate,
}
